export const EXPERIMENT_FLAG = "show-reverse-trial-opd";
export const OPD_KILL_SWITCH = "reverse-trial-opd-kill-switch";
export const TOUCH_POINT_CONFIG_FLAG = "reverse-trial-opd-config";
export const GET_DIALOG_MESSAGE_TYPE = "reverse-trial.get-dialog";
export const STEP_PREF_KEY = "reverse_trial_step";
export const TRIAL_START_DATE_PREF_KEY = "reverse_trial_start_date";
export const DIALOG_ACTION_MESSAGE_TYPE = "reverse-trial.dialog-action";
export const DISMISS_DIALOG_MESSAGE_TYPE = "reverse-trial.dismiss-dialog";
export const GET_DIALOG_SHOULD_STILL_SHOW_MESSAGE_TYPE = "reverse-trial.get-dialog-should-still-show";
export const OPT_OUT_MESSAGE_TYPE = "reverse-trial.opt-out";
export const FEEDBACK_MESSAGE_TYPE = "reverse-trial.feedback";
export const FEEDBACK_URL = "https://docs.google.com/forms/d/e/1FAIpQLSdMfL5RrrDbPr5Ud1oBm8oYDOFp_TeHLwxKHEGksUY2OMwDCQ/viewform?usp=pp_url";
export const TRIAL_DURATION_DAYS = 14;
export const MIDPOINT_THRESHOLD_DAYS = 7;
export const MS_PER_DAY = 1000 * 60 * 60 * 24;
